import script from "./TaoGopYKienNghi.vue?vue&type=script&setup=true&lang=js"
export * from "./TaoGopYKienNghi.vue?vue&type=script&setup=true&lang=js"

import "./TaoGopYKienNghi.vue?vue&type=style&index=0&id=ce1705f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ce1705f2"]])

export default __exports__